import React from "react";
import { useHistory } from "react-router-dom";
import { get } from "lodash";
import Page403 from "./error/Page403";

const ErrorHandler = ({ children }) => {
  const history = useHistory();

  switch (get(history.location.state, "errorStatusCode")) {
    case 403:
      return <Page403 />;

    // ... cases for other types of errors

    default:
      return children;
  }
};

export default ErrorHandler;
